module.exports = __webpack_public_path__ + "media/images/vision-express-d96c90d66af5698271801b779da4787b.png";